import clsx from 'clsx';
import Card from 'components/atoms/Card/Card';
import Switch from 'components/atoms/Switch/Switch';
import Txt from 'components/atoms/Txt/Txt';
import React, { useState } from 'react';

import classes from './UnsubscribeCard.module.scss';
import { graphql, useFragment, useMutation } from 'react-relay';
import useQueryStringParams from 'hooks/useQueryStringParams';
import { UnsubscribeCardViaTokenMutation } from './__generated__/UnsubscribeCardViaTokenMutation.graphql';
import Heading from 'components/atoms/Heading/Heading';

export type Props = {
  notificationsSubscriptionsRef: any;
  className?: string;
};

const notificationSubscriptionsFragment = graphql`
  fragment UnsubscribeCard_notificationSubscriptions on NotificationSubscriptions {
    id
    surveyInvites
  }
`;

const updateNotificationSubscriptionsViaTokenMutation = graphql`
  mutation UnsubscribeCardViaTokenMutation($input: UpdateNotificationSubscriptions!) {
    updateNotificationSubscriptionsViaToken(input: $input) {
      message
      notificationSubscriptions {
        id
        surveyInvites
      }
    }
  }
`;

export default function Marketing({ notificationsSubscriptionsRef, className }: Props) {
  const subscriptions = useFragment(
    notificationSubscriptionsFragment,
    notificationsSubscriptionsRef,
  );

  const queryParams = useQueryStringParams();
  const [commitMutation, isMutationInFlight] = useMutation<UnsubscribeCardViaTokenMutation>(
    updateNotificationSubscriptionsViaTokenMutation,
  );

  function updateDataLayer(accepted: boolean, type: 'surveyInvites' | 'marketing') {
    commitMutation({
      variables: {
        input: {
          [type]: accepted,
          token: queryParams['token'],
        },
      },
      onError: (error) => {
        console.error(error);
      },
      onCompleted: (response) => {
        if (
          subscriptionsChecked &&
          response.updateNotificationSubscriptionsViaToken?.notificationSubscriptions
        ) {
          setSubscriptionsChecked({
            ...subscriptionsChecked,
            ...response.updateNotificationSubscriptionsViaToken?.notificationSubscriptions,
          });
        }
      },
    });
  }

  const [subscriptionsChecked, setSubscriptionsChecked] = useState<{
    id: string;
    marketing: boolean | null;
    surveyInvites: boolean | null;
  }>();

  React.useEffect(() => {
    setSubscriptionsChecked(subscriptions);
  }, [subscriptions]);

  return (
    <Card className={clsx(className, classes.card)}>
      <Heading level={2} className={classes.h2}>
        Contact Preferences
      </Heading>
      <div className={classes.settings}>
        <Heading level={4} className={classes.h4}>
          Survey Invitations
        </Heading>
        <Txt component={'p'}>
          Enable to be notified when there are new surveys available, so you never miss a chance to
          earn LPs
        </Txt>
        <Switch
          isLoading={isMutationInFlight || !subscriptions}
          checked={subscriptionsChecked?.surveyInvites || false}
          className={classes.switch}
          onToggle={(isEnabled) => updateDataLayer(isEnabled, 'surveyInvites')}
        />
      </div>
      {/* TODO: Complete marketing changes <Txt component={'h3'}>Marketing</Txt>
      <Txt component={'p'}>
        Enable to stay up to date with our marketing communications for all the latest news and
        offers
      </Txt>
      <Switch
        isLoading={isMutationInFlight || !subscriptions}
        checked={subscriptionsChecked?.marketing || false}
        className={classes.switch}
        onToggle={(isEnabled) => updateDataLayer(isEnabled, 'marketing')}
      /> */}
    </Card>
  );
}
